import React from 'react';

const TONE_CLASSES = {
    neutral: 'badge-ghost',
    warning: 'badge-warning',
    info: 'badge-info',
    error: 'badge-error',
    accent: 'badge-accent',
    success: 'badge-success',
};

const Badge = ({ tone = 'neutral', children }) => (
    <span className={`badge badge-sm ${TONE_CLASSES[tone] || TONE_CLASSES.neutral}`}>{children}</span>
);

export default Badge;
